import sumBy from "lodash/sumBy";
import { useContext } from "@nuxtjs/composition-api";

export function useMiniMarketTeamActions() {
  const { $mutate, $query } = useContext();

  async function saveMiniMarketTeam(submitData) {
    try {
      if (submitData.id !== null) {
        const UPDATE_ZONE_TEAM = await import("./updateMiniMarketTeam.graphql");
        return await $mutate(UPDATE_ZONE_TEAM, submitData);
      } else {
        const CREATE_ZONE_TEAM = await import("./createMiniMarketTeam.graphql");
        return await $mutate(CREATE_ZONE_TEAM, submitData);
      }
    } catch (e) {
      console.error(e);
      return Promise.reject(e);
    }
  }

  async function deleteMiniMarketTeamById(id) {
    try {
      const DELETE_ZONE_TEAM = await import(
        "./deleteMiniMarketTeamById.graphql"
      );
      await $mutate(DELETE_ZONE_TEAM, { id });
    } catch (e) {
      console.error(e);
      return Promise.reject(e);
    }
  }

  async function getMiniMarketTeamById(id) {
    try {
      const GET_ZONE_TEAM = await import("./getMiniMarketTeamById.graphql");
      const { miniMarketTeamById } = await $query(GET_ZONE_TEAM, { id });
      return miniMarketTeamById;
    } catch (e) {
      console.error(e);
      return Promise.reject(e);
    }
  }

  async function getMiniMarketTeams(params) {
    try {
      const GET_ZONE_TEAMS = await import("./miniMarketTeamsDataTable.graphql");
      const {
        miniMarketTeamsDataTable: { items, pagination },
      } = await $query(GET_ZONE_TEAMS, params);
      const itemsExtended = items.map((team) => {
        const incomeBeforeStart = sumBy(team.miniMarkets, "incomeBeforeStart");
        const income = sumBy(team.miniMarkets, "income");
        const growth = income - incomeBeforeStart;
        const missingGrowth = team.targetIncomeGrowthFromStart - growth;
        const averageMonthlyUniqueTenderCount = sumBy(
          team.miniMarkets,
          "averageMonthlyUniqueTenderCount"
        );
        const tenderValue =
          sumBy(
            team.miniMarkets,
            (m) => m.income / m.averageMonthlyUniqueTenderCount
          ) / team.miniMarkets.length;

        const targetIncomeByTenderCount = sumBy(
          team.miniMarkets,
          (m) => m.averageMonthlyUniqueTenderCount * m.targetTenderPrice
        );
        const missingGrowthToTargetIncome = sumBy(
          team.miniMarkets,
          (m) =>
            m.averageMonthlyUniqueTenderCount * m.targetTenderPrice - m.income
        );
        const capacity = sumBy(team.miniMarkets, "capacity");
        const freeCapacity = sumBy(team.miniMarkets, "freeCapacity");
        const activeSubscriptionCount = sumBy(
          team.miniMarkets,
          "activeSubscriptionCount"
        );
        const possibleGrowth = sumBy(team.miniMarkets, "possibleGrowth");

        return {
          ...team,
          incomeBeforeStart,
          income,
          growth,
          missingGrowth,
          averageMonthlyUniqueTenderCount,
          tenderValue,
          targetIncomeByTenderCount,
          missingGrowthToTargetIncome,
          capacity,
          activeSubscriptionCount,
          freeCapacity,
          possibleGrowth,
        };
      });

      return {
        items: itemsExtended,
        pagination,
      };
    } catch (e) {
      console.error(e);
      return Promise.reject(e);
    }
  }

  async function getMiniMarketTeamsForAutocomplete(params) {
    try {
      const GET_ZONE_TEAMS = await import(
        "./miniMarketTeamsMinimalDataTable.graphql"
      );
      const { miniMarketTeamsDataTable } = await $query(GET_ZONE_TEAMS, params);
      return miniMarketTeamsDataTable;
    } catch (e) {
      console.error(e);
      return Promise.reject(e);
    }
  }

  return {
    saveMiniMarketTeam,
    deleteMiniMarketTeamById,
    getMiniMarketTeamById,
    getMiniMarketTeams,
    getMiniMarketTeamsForAutocomplete,
  };
}
